import {
  setAutoCompleteReturnFrom,
  setAutoCompleteReturnTo,
  setAutoCompleteFlyFrom_B,
  setAutoCompleteFlyTo_B,
  setAutoCompleteFlyFrom_0,
  setAutoCompleteFlyTo_0,
  setAutoCompleteFlyFrom_1,
  setAutoCompleteFlyTo_1,
  setAutoCompleteFlyFrom_2,
  setAutoCompleteFlyTo_2,
  setAutoCompleteFlyFrom_3,
  setAutoCompleteFlyTo_3,
  setAutoCompleteFlyFrom_4,
  setAutoCompleteFlyTo_4,
  setAutoCompleteQuoteFrom,
  setAutoCompleteQuoteTo,
  setAutoCompleteFlyFromM,
  setAutoCompleteFlyToM,
} from '../actionCreators/searchForm';
import {
  mapSearchCityAirportResponse,
  ensureAirportSuggestOptions,
  searchAirportSuggest,
  isAirportSuggestCacheReady,
} from '@gigi/airport-autosuggest';
import { env } from '../../../src/appConfig'
import { TripType, FlyingType } from "../../utils/constant";
import getApiResponse from "../../services/getApiResponse";

const ALL_AIRPORTS_URL =
  env.REACT_APP_STATIC_CONTENT + `/searchCityAirport/airports/allAirports`;

function dispatchAirportSuggest(dispatch, autoCompleteResult, tripType, inputControl) {
  if (tripType === TripType.ROUNDTRIP && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteReturnFrom(autoCompleteResult));
  } else if (tripType === TripType.ROUNDTRIP && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteReturnTo(autoCompleteResult));
  } else if (tripType === "OpenJawFlying_B" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFrom_B(autoCompleteResult));
  } else if (tripType === "OpenJawFlying_B" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyTo_B(autoCompleteResult));
  } else if (tripType === "MultiCity" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFromM(autoCompleteResult));
  } else if (tripType === "MultiCity" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyToM(autoCompleteResult));
  } else if (tripType === "MultiCity_0" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFrom_0(autoCompleteResult));
  } else if (tripType === "MultiCity_0" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyTo_0(autoCompleteResult));
  } else if (tripType === "MultiCity_1" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFrom_1(autoCompleteResult));
  } else if (tripType === "MultiCity_1" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyTo_1(autoCompleteResult));
  } else if (tripType === "MultiCity_2" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFrom_2(autoCompleteResult));
  } else if (tripType === "MultiCity_2" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyTo_2(autoCompleteResult));
  } else if (tripType === "MultiCity_3" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFrom_3(autoCompleteResult));
  } else if (tripType === "MultiCity_3" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyTo_3(autoCompleteResult));
  } else if (tripType === "MultiCity_4" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteFlyFrom_4(autoCompleteResult));
  } else if (tripType === "MultiCity_4" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteFlyTo_4(autoCompleteResult));
  } else if (tripType === "Quote" && inputControl === FlyingType.FLYING_FROM) {
    dispatch(setAutoCompleteQuoteFrom(autoCompleteResult));
  } else if (tripType === "Quote" && inputControl === FlyingType.FLYING_TO) {
    dispatch(setAutoCompleteQuoteTo(autoCompleteResult));
  }
}

async function fetchAllAirportsMapped() {
  const result = await getApiResponse(ALL_AIRPORTS_URL);
  return mapSearchCityAirportResponse(result);
}

async function fetchRemoteSuggest(query) {
  return getApiResponse(
    env.REACT_APP_STATIC_CONTENT + `/searchCityAirport/v2/${query}`
  );
}

/** Prefetch full airport list once after login / restored session. */
export const prefetchCityAirports = () => {
  return async () => {
    try {
      // Always re-ensure so hierarchy schema upgrades rematerialize.
      await ensureAirportSuggestOptions(fetchAllAirportsMapped);
    } catch (error) {
      console.log("prefetchCityAirports error:", error);
    }
  };
};

export const getCityAirport = (city, tripType, inputControl) => {
  return async (dispatch) => {
    try {
      const options = await searchAirportSuggest(city, {
        fetchAllMapped: fetchAllAirportsMapped,
        fetchRemote: fetchRemoteSuggest,
      });
      dispatchAirportSuggest(dispatch, options, tripType, inputControl);
    } catch (error) {
      console.log("error:", error);
    }
  };
};

export { isAirportSuggestCacheReady };
